import { EnvironmentProviders, Provider, inject, provideEnvironmentInitializer } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { QueriesService } from 'app/services/queries.service';
import { authInterceptor } from './auth.interceptor';

// ...

export const provideAuth = (): Array<Provider | EnvironmentProviders> =>
{
    return [
        provideHttpClient(withInterceptors([authInterceptor])),
        provideEnvironmentInitializer(() => inject(QueriesService)),
    ];
};
